import { normalize } from 'normalizr'
import { Schemas } from '@redux/schema'
import { updateEntities } from '@redux/entities'

import api from '@functions/api'

import { handleError } from '../utils'

const FETCH_REQUEST = 'contenthouse/serviceCategory/FETCH_REQUEST'
const FETCH_SUCCESS = 'contenthouse/serviceCategory/FETCH_SUCCESS'
const FETCH_FAILURE = 'contenthouse/serviceCategory/FETCH_FAILURE'

const UPDATE_REQUEST = 'contenthouse/serviceCategory/UPDATE_REQUEST'
const UPDATE_SUCCESS = 'contenthouse/serviceCategory/UPDATE_SUCCESS'
const UPDATE_FAILURE = 'contenthouse/serviceCategory/UPDATE_FAILURE'

// Initial State
const initialState = {
  errors: [],
  loaded: false,
  loading: false,
  result: {},
  updating: false,
}

// Actions
export function fetchRequest(){
  return {
    type: FETCH_REQUEST,
  }
}

export function fetchSuccess(payload = {}){
  return {
    type: FETCH_SUCCESS,
    payload,
  }
}

export function fetchFailure(errors = []){
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

export function updateRequest(){
  return {
    type: UPDATE_REQUEST,
  }
}

export function updateSuccess(){
  return {
    type: UPDATE_SUCCESS,
  }
}

export function updateFailure(errors = []){
  return {
    type: UPDATE_FAILURE,
    errors,
  }
}

// Action Creators
export function loadServiceCategories(){
  return (dispatch) => {
    dispatch(fetchRequest())
    const promise = api('/v1/service-categories')
      .then(({ data }) => {
        const normalizedJson = normalize(data, Schemas.SERVICE_CATEGORY_ARRAY)
        dispatch(updateEntities(normalizedJson))
        dispatch(fetchSuccess(data))

        return { success: true, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(fetchFailure(errors))

        return { success: false, result: errors }
      })

    return promise
  }
}

export function updateServiceCategory(serviceCategory, options = {}){
  const config = {
    method: 'PUT',
    data: serviceCategory,
  }

  return (dispatch) => {
    dispatch(updateRequest())

    const promise = api(`/v1/service-categories/${serviceCategory.id}`, options, config)
      .then(({ data }) => {
        const normalizedJson = normalize(data, Schemas.SERVICE_CATEGORY)
        dispatch(updateEntities(normalizedJson))
        dispatch(updateSuccess())
        return { success: true, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(updateFailure(errors))

        return { success: false, errors }
      })

    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}){
  const { type, payload, errors } = action

  switch (type){
    case FETCH_REQUEST:
      return {
        ...state,
        loading: true,
      }
    case FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        errors: [],
        result: payload.continuationToken,
      }
    case FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: false,
        errors,
      }
    case UPDATE_REQUEST:
      return {
        ...state,
        updating: true,
      }
    case UPDATE_SUCCESS:
      return {
        ...state,
        updating: false,
        errors: [],
      }
    case UPDATE_FAILURE:
      return {
        ...state,
        updating: false,
        errors,
      }
    default:
      return state
  }
}
